module.exports = __webpack_public_path__ + "img/img_service_01.e1b02ed6.jpg";